import {
  sendMsg,
  ENDPOINT_REQUEST as userServicesRequest,
  SERVICES_REQUEST as services,
} from '../../configurations';
import { systemRqErr } from '../../constants/app';

// Call services to pre-active account
export const preActiveAccount = (params, callback) => {
  sendMsg(services.COMMON, userServicesRequest.iAUTH.PRE_ACTIVE_ACCOUNT, params).post(res => {
    callback(res);
  })
}

// Call services to active account
export const activeAccount = (params, callback) => {
  sendMsg(services.COMMON, userServicesRequest.iAUTH.ACTIVE_ACCOUNT, params).post(res => {
    callback(res);
  })
}

// Call services to login
export const login = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_LOGIN, params).post(res => {
    callback(res);
  })
}

// Call services to check Auth
export const checkAuth = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_CHECK_AUTH, params).post(res => {
    callback(res);
  })
}

// Call services to logout
export const logout = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_LOGOUT, params).post(res => {
    callback(res);
  })
}

// Call services to register
export const register = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_REGISTER, params).post(res => {
    callback(res);
  })
}

// Call services to verify account
export const verifyAccount = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_VALIDATE, params).post(res => {
    callback(res);
  })
}

// Call services to change password
export const changePassword = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_CHANGE_PASSWORD, params).post(res => {
    callback(res);
  })
}

// Call services to reset password
export const resetPassword = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_RESET_PASSWORD, params).post(res => {
    callback(res);
  })
}

export const otpRegister = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.OTP_REGISTER, params).get(res => {
    callback(res);
  })
}

export const otpRegisterVerify = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.OTP_REGISTER_VERIFY, params).get(res => {
    callback(res);
  })
}

// Call services to check session
export const checkSession = (params, callback, failCallback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.USER_CHECK_SESSION, params).get(callback, failCallback)
}

export const otpTicketVerify = (params, callback) => {
  sendMsg(services.AUTH, userServicesRequest.iAUTH.OTP_TICKET_VERIFY, params).post(res => {
    callback(res);
  })
}

export const applySelfDefinedUserId = (params,callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.APPLY_SELF_DEFINED_USER_ID,params).post(res => {
    callback(res);
  })
}

export const identityType = (params,callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.IDENTITY_CARD_TYPE,params).get(res => {
    callback(res);
  })
}

export const getCaptchaByWS = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.IMAGE_CAPTCHA_BY_WS, params).get(callback)
}

//Call services bcanStatus
export const bcanStatus = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.BCAN_STATUS, params).get(res => {
    callback(res);
  })
}

export const bcanConsent = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.BCAN_CONSENT, params).post(res => {
    callback(res);
  })
}

export const accountDetail = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.ACCOUNT_DETAIL, params).get(
    (res) => {
      callback(res);
    }
  );
};

export const bankAccountRegister = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iAUTH.BANK_ACCOUNT_REGISTER, params).post(
    (res) => {
      callback(res);
    }
  );
};

export const accepRegisterEdda = (params, callback) => {
	sendMsg(services.EQT, userServicesRequest.iAUTH.EDDA_REGISTER, params).post((res) => {
		callback(res);
	});
};

export const acceptAccountDetails = (params, callback) => {
	sendMsg(services.EQT, userServicesRequest.iAUTH.ACCOUNT_DETAILS, params).get((res) => {
		callback(res);
	});
};